import { Rarity } from '__generated__/globalTypes';
import { CheckboxFilters } from 'components/collections/filters/CheckboxFilters';
import { StartedOnlyFilter } from 'components/collections/filters/StartedOnlyFilter';
import {
  CollectionsFilterType,
  CollectionsFiltersState,
  RarityCount,
  SeasonCount,
} from 'components/collections/filters/types';

type Props = {
  filtersState: CollectionsFiltersState;
  raritiesCount: RarityCount[];
  seasonsCount: SeasonCount[];
  hide?: CollectionsFilterType[];
  onFiltersChange: (newState: CollectionsFiltersState) => void;
};

export const DesktopCollectionsFilters = ({
  raritiesCount,
  seasonsCount,
  filtersState,
  hide,
  onFiltersChange,
}: Props) => {
  const onRaritiesChange = (newRarities: Rarity[] | undefined) => {
    onFiltersChange({ ...filtersState, rarities: newRarities });
  };

  const onSeasonsChange = (newSeasons: number[] | undefined) => {
    onFiltersChange({ ...filtersState, seasonStartYears: newSeasons });
  };

  const onStartedOnlyChange = (startedOnly: boolean) => {
    onFiltersChange({ ...filtersState, startedOnly });
  };

  return (
    <>
      <CheckboxFilters
        rarities={filtersState.rarities}
        raritiesCount={raritiesCount}
        seasonStartYears={filtersState.seasonStartYears}
        seasonsCount={seasonsCount}
        hide={hide}
        onRaritiesChange={onRaritiesChange}
        onSeasonsChange={onSeasonsChange}
      />
      {!hide?.includes(CollectionsFilterType.startedOnly) && (
        <StartedOnlyFilter
          startedOnly={filtersState.startedOnly}
          onChange={onStartedOnlyChange}
        />
      )}
    </>
  );
};
